<template>
  <div class="d-flex flex-column flex-lg-row-fluid gap-7 gap-lg-10">
    <div class="card card-flush" :class="loading && 'overlay overlay-block'">
      <div class="card-body" :class="addClass">
        <slot></slot>

        <div class="separator mb-6 mt-6"></div>

        <div class="d-flex justify-content-end" v-if="!hideSubmitButton">
          <slot name="action">
            <submit-button label="Gravar" :disabled="form.hasErrors" :processing="loading"/>
          </slot>
        </div>
      </div>
      <overlay :loading="loading"/>
    </div>
  </div>
</template>

<script>
import Overlay from "./Overlay";
import SubmitButton from "./SubmitButton";

export default {
  components: {
    Overlay,
    SubmitButton
  },

  props: {
    form: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    addClass: {
      type: String,
      required: false
    },
    hideSubmitButton: {
      type: Boolean,
      required: false
    }
  }
}
</script>
